module.exports = __webpack_public_path__ + "static/media/speedweaver.10ed67b8.svg";